import LeadsStipulationTableBlock from './LeadsStipulationTableBlock'
export default LeadsStipulationTableBlock
